import React, { Component } from "react";
import Loader from "react-loader-spinner";

import { I18nContext } from "../../I18nProvider";

import "./Loading.css";

class Loading extends Component {
  static contextType = I18nContext;
  render() {
    const appText = this.context;
    return (
      <div className="loading" hidden={this.props.hidden}>
        <div>
          <Loader
            type="TailSpin"
            color="rgb(56, 56, 56)"
            height={25}
            width={25}
          />
          {/* <div className="loader-text">Submitting your job, Please wait...</div> */}
          <div className="loader-text">{appText.T151}</div>
        </div>
      </div>
    );
  }
}

export default Loading;
